import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';

export function composeHorizontalGapSizeClasses(hGap: Adaptive<number>): string {
    if (typeof hGap === 'object') {
        return clsx(
            hGap.base && `gap-x-${hGap.base}`,
            hGap.sm && `sm:gap-x-${hGap.sm}`,
            hGap.md && `md:gap-x-${hGap.md}`,
            hGap.lg && `lg:gap-x-${hGap.lg}`,
            hGap.xl && `xl:gap-x-${hGap.xl}`,
            hGap['2xl'] && `2xl:gap-x-${hGap['2xl']}`
        );
    }

    return `gap-x-${hGap}`;
}
